import React, { useEffect, useState } from "react";
import "raf/polyfill"
import "regenerator-runtime/runtime"
import io from "socket.io-client";
import { v4 as uuidv4 } from "uuid";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import Game from "@3d-components/Chat3D";
import {GameContextProvider} from "@3d-components/GameContextProvider";
import {AI_CONTEXT_CHANGED, eventBus} from "@3d-components/bus";

type Props = {}

const SOCKET_SERVER_URL = process.env.SOCKET_SERVER_URL;

const queryClient = new QueryClient();

const wrapperStyle: React.CSSProperties = {
   width: '100%',
   height: '100%'
};

export default function LoadingH5pEvent3D({}: Props) {
    const [iframeSrc, setIframeSrc] = useState("");

    useEffect(() => {
        const generatedSessionId = uuidv4();

        const iframeUrl = `https://lms.vmb.edu.vn/xblock/block-v1:VMB+OE0000+2024_10+type@vertical+block@f664da01e8a8435ab028424333095016?exam_access=&recheck_access=1&show_bookmark=0&show_title=0&view=student_view&vmb-app-session-id=${generatedSessionId}`;
        setIframeSrc(iframeUrl);
        
        const socketConnection = io(SOCKET_SERVER_URL);

        socketConnection.on("connect", () => {
            socketConnection.on("joined_group", (message) => {
                console.log("joined_group: Message from room:", message);
                console.log(`Site connected to Socket.IO server. Joined group with sessionId: ${generatedSessionId}`);
            });
            
            socketConnection.on("h5p_event", async (message) => {
                console.log("Site H5p_event:", message);
                const { data, type } = message;
                
                if(type === "custom" && data && data.type === "textToSpeech") {
                    eventBus.emit(AI_CONTEXT_CHANGED, data.content);
                }
            });
            
            socketConnection.emit("join_group", { sessionId: generatedSessionId });
        });
        
        return () => {
            socketConnection.disconnect();
        };
    }, []);
    
    return (
        <div>
            <div style={wrapperStyle}>
                <GameContextProvider humanoidRef={null} currentSoundRef={null}>
                    <QueryClientProvider client={queryClient}>
                        <Game hasGoogleApiKey={false}></Game>
                    </QueryClientProvider>
                </GameContextProvider>
            </div>
        </div>
    )
}